import { node } from "~/util/dom";
import ParamsItemPUBTDateTime from "~/route4/params/item.pubt.datetime";
import ParamsItemPUBTPreferences from "~/route4/params/item.pubt.preferences";
import { ROUTE_CONST } from "../const";

export default class ParamsItemPubt {
	#container: HTMLDivElement;

	#items: [ParamsItemPUBTDateTime, ParamsItemPUBTPreferences];

	constructor(type: any, routeType: number) {
		this.#container = node("div", { className: type.name });
		this.#items = null;

		this.#build(routeType);
	}

	destroy() {
		this.#container = null;
		this.#items.forEach(item => {
			item.destroy();
		});
		this.#items = null;
	}

	get input() {
		return this.#container;
	}

	get state() {
		return {
			...this.#items[0].state,
			flags: this.#items[1].state,
		} as {
			datetime: string;
			departure: boolean;
			flags: {
				[key: string]: number;
			}
		};
	}

	set state(state) {
		this.#items[0].state = {
			datetime: state.datetime,
			departure: state.departure,
		};

		this.#items[1].state = state.flags;
	}

	#build(routeType: number) {
		const dateTime = new ParamsItemPUBTDateTime(() => {
			this.#change();
		});

		this.#container.appendChild(dateTime.label);

		const preferences = new ParamsItemPUBTPreferences(() => {
			this.#change();
		});

		this.#container.appendChild(preferences.label);

		if (!Mapy.CUS.userweb?.routeNewHD || routeType !== ROUTE_CONST.TYPE_PUBT) {
			preferences.label.classList.add("pubt-preferences-button--disabled");
		}

		this.#items = [dateTime, preferences];
	}

	#change() {
		const event = new CustomEvent("params-pubt-change");

		this.#container.dispatchEvent(event);
	}
}
